<script setup>
import { ref, watch } from 'vue'

const props = defineProps({ visual: { type: Object, required: true } })
const revealed = ref(new Set())
watch(() => props.visual, () => { revealed.value = new Set() })
function toggle(index) {
  const next = new Set(revealed.value)
  next.has(index) ? next.delete(index) : next.add(index)
  revealed.value = next
}
</script>

<template>
  <div class="language-visual">
    <div class="language-visual-heading"><span aria-hidden="true">Aa</span><strong>{{ visual.title }}</strong></div>
    <div v-if="visual.kind === 'table'" class="language-table-wrap" tabindex="0" :aria-label="visual.title">
      <table><thead><tr><th v-for="column in visual.columns" :key="column" scope="col">{{ column }}</th></tr></thead><tbody><tr v-for="(row, index) in visual.rows" :key="index"><td v-for="(cell, column) in row" :key="column">{{ cell }}</td></tr></tbody></table>
    </div>
    <div v-else-if="visual.kind === 'vocabulary'" class="vocabulary-grid">
      <button v-for="(item, index) in visual.items" :key="index" type="button" :data-lookup-term="item.label" :aria-expanded="revealed.has(index)" @click="toggle(index)">
        <strong lang="en">{{ item.label }}</strong><span>{{ revealed.has(index) ? item.text : 'Chạm để xem nghĩa' }}</span>
      </button>
    </div>
    <ol v-else class="language-chain">
      <li v-for="(item, index) in visual.items" :key="index"><span>{{ String(index + 1).padStart(2, '0') }}</span><div><strong>{{ item.label }}</strong><p>{{ item.text }}</p></div></li>
    </ol>
  </div>
</template>

<style scoped>
.language-visual { margin: 20px 0; border: 1px solid var(--journey-line, #d9c3eb); border-radius: 16px; background: var(--journey-soft, #f7f0ff); padding: 18px; }
.language-visual-heading { display: flex; gap: 10px; align-items: center; margin-bottom: 14px; color: var(--journey-ink, #6b478f); }
.language-visual-heading > span { display: grid; place-items: center; width: 34px; height: 34px; background: white; border-radius: 10px; font-weight: 800; }
.language-visual-heading strong { font-size: 14px; }
.language-table-wrap { max-width: 100%; overflow-x: auto; }
table { border-collapse: collapse; width: 100%; background: white; font-size: 13px; line-height: 1.7; }
th, td { text-align: left; padding: 12px; border-bottom: 1px solid var(--journey-line, #d9c3eb); min-width: 130px; white-space: pre-line; vertical-align: top; }
th { color: var(--journey-ink, #6b478f); }
.vocabulary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(145px, 1fr)); gap: 10px; }
.vocabulary-grid button { padding: 16px 12px; min-height: 88px; border: 1px solid var(--journey-line, #d9c3eb); border-radius: 12px; background: white; cursor: pointer; text-align: left; }
.vocabulary-grid button strong, .vocabulary-grid button span { display: block; }
.vocabulary-grid button strong { color: var(--journey-ink, #6b478f); font-size: 16px; margin-bottom: 8px; }
.vocabulary-grid button span { color: #68718d; font-size: 12px; }
.language-chain { margin: 0; padding: 0; list-style: none; display: grid; gap: 12px; }
.language-chain li { display: flex; align-items: flex-start; gap: 12px; padding: 14px; border-radius: 12px; background: white; }
.language-chain li > span { color: var(--journey-ink, #6b478f); font-weight: 800; font-size: 12px; padding-top: 3px; }
.language-chain li > div { min-width: 0; }
.language-chain strong { font-size: 13px; }
.language-chain p { white-space: pre-line; overflow-wrap: anywhere; margin: 6px 0 0; font-size: 13px; line-height: 1.8; }
</style>
